import axios from 'axios'

let imgDomain = 'https://img.qiluyidian.net/'

function toDouble(val) {
  if (isNaN(val)) return
  return val < 10 ? ("0" + val) : val
}

// 上传文件随机key
function fileRandomKey(type='') {
  let date = new Date()
  return `${date.getFullYear()}/${toDouble(date.getMonth() + 1)}/${toDouble(date.getDate())}/activity/${parseInt(new Date().getTime() / 1000)}${Math.random().toString(36).substring(2)}${type}`
}


export async function uploadImage(fileInfo) {
    return new Promise((resolve, reject) => {
        axios.post("https://gateway.ql1m.com/gateway/editor/manage/common/back/getQiniuUptoken.do").then((res) => {
            let token = res.data.data.uptoken;

            // 此时可以自行将文件上传至服务器
            console.log(fileInfo)
            // this.cover = file.content
            let {file} = fileInfo
            let timeKey = new Date().getTime() + file.name
            // console.log(fileInfo)
            let fileData = new FormData()
            fileData.append('token', token)
            fileData.append('key', timeKey)
            fileData.append('file', file)
            axios.post('https://up.qiniup.com/', fileData).then(data => {
                let {data: {key, hash}} = data
                if (!key) {
                    this.$toast('网络错误,请稍后重试')
                    return false
                }
                resolve(imgDomain + key)
            })
        })
    })

}

export async function uploadFile(fileInfo) {
  return new Promise((resolve, reject) => {
    axios.post("https://gateway.ql1m.com/gateway/editor/manage/common/back/getQiniuUptoken.do").then((res) => {
      let token = res.data.data.uptoken

      // 此时可以自行将文件上传至服务器
      console.log(fileInfo)
      // this.cover = file.content
      let {file} = fileInfo
      let timeKey = new Date().getTime() + file.name
      // console.log(fileInfo)
      let fileData = new FormData()
      fileData.append('token', token)
      fileData.append('key', fileRandomKey('.' + getLastExtension(file.name)))
      fileData.append('file', file)
      axios.post('https://up.qiniup.com/', fileData).then(data => {
        let {data: {key, hash}} = data
        if (!key) {
          this.$toast('网络错误,请稍后重试')
          return false
        }
        const fileDetail = {
          imgUrl: imgDomain + key,
          name: file.name,
          type: getLastExtension(file.name)
        }
        resolve(fileDetail)
      })
    })
  })
}

function getLastExtension(filename) {
  // 使用正则表达式匹配文件名中最后一个点号之后的内容
  const match = filename.match(/\.([^\.]+)$/);

  // 如果匹配成功，返回匹配到的扩展名（不包括点号）
  if (match) {
    return match[1]
  } else {
    // 如果没有匹配到扩展名，返回空字符串
    return ''
  }
}
